import { Component, OnInit } from '@angular/core';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-elife-detail',
  templateUrl: './elife-detail.component.html',
  styleUrls: ['./elife-detail.component.scss']
})
export class ElifeDetailComponent implements OnInit {

  sku: any;
  skuDetail:any;
  keyBenefits: any=[];

  constructor(
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
  ) { }

  async ngOnInit() {
    this.sku = this.SKUDS.get();
    await this.skuDetails(this.sku.skuId).then((resp) => this.skuDetail=resp);
    if(this.skuDetail && this.skuDetail._embedded.keyBenefits) {
      this.SKUDS.getAdditionalSkus(this.skuDetail._embedded.keyBenefits._links.href).subscribe(resp=>{
        this.keyBenefits=resp['keyBenefits'];
      })
    }
  }

  private async skuDetails(id: string) {
    const response = await this.SKUDS.geteShopSKU(id)
      .toPromise()
      .catch((e) => this.UTS.log(e));
    return response;
  }

}
